export const WHATSAPP_NUMBER = "3365328881";
export const WHATSAPP_DISPLAY = "06 65 32 88 81";
export const EMAIL = "fkconseil.evenement@gmail.com";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const DEFAULT_WA_MESSAGE =
  "Bonjour FK Conseil & Événement, je souhaite un devis pour la mise à disposition de serveurs / maître d'hôtel pour mon événement.";
